@if (!match) {
    <h1 mat-dialog-title class="text-center">
        {{ 'ADD_MATCH.SELECT_PLAYERS' | translate }}
    </h1>
}
@if (match && match.started) {
    <h1 mat-dialog-title class="text-center">
        {{ 'ADD_MATCH.SCORE' | translate }}
    </h1>
}
@if (match && !match.started) {
    <h1 mat-dialog-title class="text-center">
        {{ 'ADD_MATCH.START_SET' | translate: { currentSet: match.sets.length + 1 } }}
    </h1>
}

<div mat-dialog-content class="pb-0">
    <div class="toolbar">
        <swal
            #saveSwal
            [title]="'ADD_MATCH.SAVE_MATCH' | translate"
            (confirm)="saveActiveMatch($event)"
            [input]="'text'"
            [inputValue]="'ADD_MATCH.SAVE_MATCH_DEFAULT_NAME' | translate"
            [showCancelButton]="true"
        ></swal>

        <button color="warn" [swal]="dismissSwal" class="toolbar-close d-block d-md-none" mat-mini-fab>
            <mat-icon class="mt-1">close</mat-icon>
        </button>

        <div class="d-flex flex-row flex-wrap gap-2 justify-content-center justify-content-md-end mb-2 mb-md-0 mt-1">
            @if (!match) {
                <button mat-mini-fab (click)="togglePlayersSearchBar()" [matTooltip]="'ADD_MATCH.SEARCH' | translate">
                    <mat-icon>search</mat-icon>
                </button>
            }
            @if (!match && savedMatchesCount > 0) {
                <button
                    (click)="openSavedMatchesDialog()"
                    mat-mini-fab
                    color="primary"
                    [matTooltip]="'ADD_MATCH.LOAD_SAVED_MATCH' | translate"
                >
                    <mat-icon [matBadge]="savedMatchesCount">open_in_browser</mat-icon>
                </button>
            }
            @if (match?.started && timers?.paused) {
                <button [swal]="saveSwal" mat-mini-fab color="primary" [matTooltip]="'ADD_MATCH.SAVE_MATCH_TOOLTIP' | translate">
                    <mat-icon>save</mat-icon>
                </button>
            }
            @if (
                match?.started &&
                settings.scoreEnteringMode === scoreEnteringMode.Course &&
                (match.sets.at(-1)?.goals.length || match.sets.length > 1)
            ) {
                <button (click)="undoLastGoal()" mat-mini-fab color="accent" [matTooltip]="'ADD_MATCH.UNDO_LAST_GOAL' | translate">
                    <mat-icon>undo</mat-icon>
                </button>
            }
            @if (match?.started && !timers?.paused) {
                <button (click)="toggleTimerPause()" mat-mini-fab color="accent" [matTooltip]="'ADD_MATCH.PAUSE_MATCH' | translate">
                    <mat-icon>pause</mat-icon>
                </button>
            }
            @if (match?.started && timers?.paused) {
                <button (click)="toggleTimerPause()" mat-mini-fab color="primary" [matTooltip]="'ADD_MATCH.RESUME_MATCH' | translate">
                    <mat-icon>play_arrow</mat-icon>
                </button>
            }

            @if (!match) {
                <button mat-mini-fab (click)="sendInviteNotification()" [matTooltip]="'ADD_MATCH.SEND_INVITE' | translate">
                    <mat-icon>outgoing_mail</mat-icon>
                </button>
            }
            @if (!match) {
                <button mat-mini-fab (click)="openGameSettings()" [matTooltip]="'ADD_MATCH.OPEN_SETTINGS' | translate">
                    <mat-icon>settings</mat-icon>
                </button>
            }

            @if (match && !match.started && match.autoBalanceData?.length) {
                <button mat-mini-fab (click)="openAutoBalanceInfo()" [matTooltip]="'ADD_MATCH.AUTO_BALANCE_INFO' | translate">
                    <mat-icon>question_mark</mat-icon>
                </button>
            }

            @if (match && match.started && match.settings.gameMode !== gameMode.OneAgainstOne) {
                <button
                    [disabled]="!playerSwitchEnabled()"
                    class="settings-link"
                    mat-mini-fab
                    (click)="setStartedFalse()"
                    [matTooltip]="'ADD_MATCH.CHANGE_PLAYERS' | translate"
                >
                    <mat-icon>sync</mat-icon>
                </button>
            }

            <button
                color="warn"
                [swal]="dismissSwal"
                class="d-none d-md-block"
                mat-mini-fab
                [matTooltip]="'ADD_MATCH.CLOSE_MATCH' | translate"
            >
                <mat-icon class="mt-1">close</mat-icon>
            </button>
        </div>

        <swal
            #dismissSwal
            title="{{ 'ADD_MATCH.DISMISS_CONFIRM' | translate }}"
            icon="question"
            [showCancelButton]="true"
            [focusConfirm]="true"
            (confirm)="dismiss()"
        >
        </swal>

        <mat-menu #settingsMenu="matMenu">
            <button (click)="sendInviteNotification()" mat-menu-item>
                <mat-icon>notifications</mat-icon>{{ 'ADD_MATCH.SEND_JOIN_REQUEST' | translate }}
            </button>
        </mat-menu>
    </div>

    @if (timers && match?.started) {
        <div class="d-flex justify-content-center gap-1 timers mb-1 mb-lg-3">
            <mat-icon>schedule </mat-icon>
            <span> {{ timers.fromMatchStart | timespan: 'hh?:mm:ss' }} </span><span>{{ timers.fromSetStart | timespan: 'hh?:mm:ss' }}</span>
            @if (settings?.scoreEnteringMode === 'course') {
                <span>{{ timers.fromLastGoal | timespan: 'hh?:mm:ss' }}</span>
            }
        </div>
    }
    @if (!match) {
        <div class="d-flex flex-column">
            @if (showPlayersSearch) {
                <div class="input-group mb-3">
                    <input
                        #searchBarInput
                        type="text"
                        class="form-control"
                        [placeholder]="'ADD_MATCH.SEARCH_PLACEHOLDER' | translate"
                        aria-label="Username"
                        [(ngModel)]="playerSearchTerm"
                        (ngModelChange)="playerSearchTerm$.next($event)"
                        cdkFocusInitial
                    />
                    <span class="input-group-text"><i class="fas fa-search"></i></span>
                </div>
            }
            <app-new-match-players-mode
                class="align-self-center mb-2"
                [value]="settings.gameMode"
                (valueChange)="gameModeChanged($event)"
            ></app-new-match-players-mode>
            @if (settings?.playerSelectionMode === playerSelectionMode.Players || settings?.gameMode === gameMode.OneAgainstOne) {
                <div class="row section">
                    @for (p of filteredPlayers; track p; let ix = $index) {
                        <app-chip [selected]="isSelected(p)" (selectedChange)="selectPlayer(p)" class="col-12 col-md-4" [id]="'chip_' + ix">
                            {{ p.displayName }}
                        </app-chip>
                    }
                </div>
            }
            @if (settings?.playerSelectionMode === playerSelectionMode.NamedTeams && settings?.gameMode === gameMode.TwoAgainstTwo) {
                <div class="row section">
                    @for (p of filteredNamedTeams; track p; let ix = $index) {
                        <app-chip
                            [selected]="isTeamSelected(p)"
                            (selectedChange)="selectTeam(p)"
                            class="col-12 col-md-4 px-2 pb-2"
                            [id]="'chip_' + ix"
                        >
                            {{ p.teamName }}
                        </app-chip>
                    }
                </div>
            }
        </div>
    }
    @if (settings && match) {
        <div>
            @if (settings?.scoreEnteringMode === 'score') {
                <app-match-score [match]="match" [autoTeamBalance]="autoTeamBalance"></app-match-score>
            }
            @if (settings?.scoreEnteringMode === 'course') {
                <div>
                    @if (match.started) {
                        <app-match-course></app-match-course>
                    } @else {
                        <app-start-match-set></app-start-match-set>
                    }
                </div>
            }
        </div>
    }
</div>
